import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_time_picker = _resolveComponent("el-time-picker")!

  return (_openBlock(), _createBlock(_component_el_time_picker, {
    id: _ctx.id == null ? _ctx.prop : _ctx.id,
    modelValue: _ctx.localModelValue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localModelValue) = $event)),
    dir: _ctx.dir,
    onChange: _cache[1] || (_cache[1] = (value) => _ctx.emitEvent('change', value)),
    format: "HH:mm",
    "value-format": "HH:mm",
    label: _ctx.ariaLabel,
    disabled: _ctx.disabled,
    readonly: _ctx.readonly,
    placeholder: _ctx.placeholder,
    size: _ctx.size,
    autofocus: _ctx.autofocus,
    class: "w-100",
    "popper-class": "modal-popper",
    teleported: true
  }, null, 8, ["id", "modelValue", "dir", "label", "disabled", "readonly", "placeholder", "size", "autofocus"]))
}